// Real pages from DRUM READY Volume 1 go here (WebP). Empty = the "Look inside" section stays hidden.
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [];
